function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { fg } from '@atlaskit/platform-feature-flags';
import { expVal } from '../../../expVal';
var isDnDStyleChange = function isDnDStyleChange(style) {
  return style.startsWith('anchor-name: --node-anchor');
};
var parseStyleSet = function parseStyleSet(style) {
  if (!style) {
    return null;
  }
  var set = new Set();
  var _iterator = _createForOfIteratorHelper(style.split(';')),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      var t = part.trim();
      if (t) {
        set.add(t);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return set;
};

/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */
function isDnDStyleMutation(_ref) {
  var target = _ref.target,
    attributeName = _ref.attributeName,
    oldValue = _ref.oldValue,
    newValue = _ref.newValue;
  if (!fg('platform_editor_exclude_dnd_anchor_name_from_ttvc')) {
    return false;
  }
  if (!expVal('platform_editor_tables_scaling_css', 'excludeDnD', false)) {
    return false;
  }
  if (!(target instanceof Element)) {
    return false;
  }
  if (attributeName !== 'style') {
    return false;
  }
  var oldStyles = parseStyleSet(oldValue);
  var newStyles = parseStyleSet(newValue);
  var isDnDMutation = false;
  var _iterator2 = _createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var s = _step2.value;
      if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
        if (!isDnDStyleChange(s)) {
          return false;
        }
        isDnDMutation = true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _s = _step3.value;
      if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
        if (!isDnDStyleChange(_s)) {
          return false;
        }
        isDnDMutation = true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return isDnDMutation;
}
export default isDnDStyleMutation;